const HEX_CHUNKS: [number, number][] = [
  [0, 8],
  [8, 12],
  [12, 16],
  [16, 20],
  [20, 32],
]

const generateUuidV4 = (): ReturnType<Crypto['randomUUID']> => {
  const bytes = new Uint8Array(16)

  if (typeof crypto.getRandomValues === 'function') {
    crypto.getRandomValues(bytes)
  } else {
    for (let index = 0; index < bytes.length; index += 1) {
      bytes[index] = Math.floor(Math.random() * 256)
    }
  }

  // RFC 4122: set version (4) and variant bits
  bytes[6] = ((bytes[6] ?? 0) & 0x0f) | 0x40
  bytes[8] = ((bytes[8] ?? 0) & 0x3f) | 0x80

  const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('')
  return HEX_CHUNKS.map(([start, end]) => hex.slice(start, end)).join('-') as ReturnType<
    Crypto['randomUUID']
  >
}

const POLYFILLS = [
  {
    execute: () => {
      if (typeof crypto === 'undefined') {
        const gThis = window.globalThis || window || self
        gThis.crypto = {} as Crypto
      }

      crypto.randomUUID = generateUuidV4
    },
    isNeeded: () =>
      typeof crypto === 'undefined' ||
      typeof crypto !== 'object' ||
      typeof crypto.randomUUID !== 'function',
  },
]

export default defineNuxtPlugin({
  parallel: false,
  setup: async () => {
    await Promise.all(
      POLYFILLS.filter(({ isNeeded }) => isNeeded()).map(({ execute }) => execute()),
    )
  },
})
